import _ from 'lodash';
import React from 'react';
import pipelineActivityTypes from '~/lookups/pipeline-activity-types';
import MultiSelect from '../MultiSelect';

export default function PipelineActivityTypeFilter({
  placeholder = 'Pipeline Activity Type',
  name,
  value,
  onChange,
  entity = 'opportunity',
}) {
  const options = _.values(pipelineActivityTypes[entity]);

  return (
    <MultiSelect.Filter
      icon="filter"
      placeholder={placeholder}
      name={name}
      value={value}
      renderValue={(value) => value.map((v) => v.name).join('; ')}
      options={options}
      onChange={onChange}
    />
  );
}
